import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from '../..'
import { priceNotation } from '../../../utils/safe'

const TotaleCosti = ({ item }) => {
  return (
    <>
      <div className="row">
        <div className="col col-md-5">
          <p className="totale-costi__dati">
            <Trans chiave="Totale prodotti" />
          </p>
        </div>
        <div className="col col-md-7">
          <p className="totale-costi__dati__value">{priceNotation(item.valoreMerce, 3)} €</p>
        </div>
      </div>

      {item?.valorePersonalizzazione > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati">
              <Trans chiave="Personalizzazione" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati__value">
              {priceNotation(item.valorePersonalizzazione, 3)} €
            </p>
          </div>
        </div>
      )}
      {(item.valoreConfezionamento > 0 ||
        item.valoreImpianto > 0 ||
        item?.valoreGestione > 0 ||
        item?.valoreTracciaturaLogo > 0 ||
        item?.valoreSupplementiMinimiDiStampa > 0) && (
        <div className="row">
          <div className="col">
            <p className="totale-costi__dati">
              <Trans chiave="Altri costi personaliz." />
            </p>
          </div>
          <div className="col">
            <p className="totale-costi__dati__value">
              {priceNotation(
                item.valoreConfezionamento +
                  item.valoreImpianto +
                  item.valoreGestione +
                  item.valoreTracciaturaLogo +
                  item.valoreSupplementiMinimiDiStampa,
                3
              )}{' '}
              €
            </p>
          </div>
        </div>
      )}
      {item.valoreConfezionamento > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Confezionamento" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreConfezionamento, 3)} €
            </p>
          </div>
        </div>
      )}
      {item.valoreImpianto > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Impianti" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreImpianto, 2)} €
            </p>
          </div>
        </div>
      )}
      {item.valoreTracciaturaLogo > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Tracciatura Logo" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item?.valoreTracciaturaLogo, 2)} €
            </p>
          </div>
        </div>
      )}
      {item.valoreSupplementiMinimiDiStampa > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Supplementi minimi di stampa" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item?.valoreSupplementiMinimiDiStampa, 2)} €
            </p>
          </div>
        </div>
      )}
      {item?.valoreGestione > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Avviamento" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreGestione, 2)} €
            </p>
          </div>
        </div>
      )}

      {(item.valoreScontoImballi != 0 ||
        item.valoreScontoMerce != 0 ||
        item.valoreScontoPersonalizzazione != 0 ||
        item.valoreScontoGestione != 0 ||
        item.valoreScontoImpianto != 0 ||
        item.valoreScontoTrasporto != 0) && (
        <p className="totale-costi__dati">
          <Trans chiave="Sconti" />
        </p>
      )}
      {item?.valoreScontoImballi !== 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Sconto Imballi" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreScontoImballi, 2)} €
            </p>
          </div>
        </div>
      )}
      {item?.valoreScontoMerce !== 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Sconto Merce Neutra" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreScontoMerce, 2)} €
            </p>
          </div>
        </div>
      )}
      {item?.valoreScontoPersonalizzazione !== 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Sconto personalizzazione" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreScontoPersonalizzazione, 2)} €
            </p>
          </div>
        </div>
      )}
      {item?.valoreScontoGestione !== 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Sconto avviamento" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreScontoGestione, 2)} €
            </p>
          </div>
        </div>
      )}
      {item?.valoreScontoImpianto !== 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Sconto impianti" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreScontoImpianto, 2)} €
            </p>
          </div>
        </div>
      )}
      {item?.valoreScontoTrasporto !== 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati-detail">
              <Trans chiave="Sconto spedizione" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati-detail__value">
              {priceNotation(item.valoreScontoTrasporto, 2)} €
            </p>
          </div>
        </div>
      )}

      {item?.ValoreSupplementiMinimiStampa > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati">
              <Trans chiave="Supplementi minimi stampa" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati__value">
              {priceNotation(item?.ValoreSupplementiMinimiStampa, 2)} €
            </p>
          </div>
        </div>
      )}
      {item.valoreTrasporto > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati">
              <Trans chiave="Spedizione" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati__value">{priceNotation(item.valoreTrasporto, 2)} €</p>
          </div>
        </div>
      )}
      {item.valoreSpeseSiae != 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati">
              <Trans chiave="Spese SIAE" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati__value">{priceNotation(item.valoreSpeseSiae, 2)} €</p>
          </div>
        </div>
      )}
      <div className="row">
        <div className="col col-md-5">
          <p className="totale-costi__dati">
            <Trans chiave="Totale netto" />
          </p>
        </div>
        <div className="col col-md-7">
          <p className="totale-costi__dati__value">{priceNotation(item.totaleImponibile, 2)} €</p>
        </div>
      </div>
      {item?.totaleIva > 0 && (
        <div className="row">
          <div className="col col-md-5">
            <p className="totale-costi__dati">
              <Trans chiave="IVA" />
            </p>
          </div>
          <div className="col col-md-7">
            <p className="totale-costi__dati__value">{priceNotation(item.totaleIva, 2)} €</p>
          </div>
        </div>
      )}
      <div className="lineSeparator lineSeparator--sm" />
      <div className="row">
        <div className="col col-md-5">
          <p className="totale-costi__dati">
            <strong>
              <Trans chiave="TOTALE" />
            </strong>
          </p>
        </div>
        <div className="col col-md-7">
          <p className="totale-costi__dati__value">
            <strong>{priceNotation(item.totaleDocumento, 2)} €</strong>
          </p>
        </div>
      </div>
    </>
  )
}

TotaleCosti.propTypes = {
  item: PropTypes.object,
}

export default TotaleCosti
